import React from "react";
import PropTypes from 'prop-types';
import { Row, Col, Container } from "react-bootstrap";
import SvgIcon from '../../Helpers/Svg/SvgIcon';
import { Button, lighten } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { getSessionStorageItem,
        SESSION_STORAGE_ACCOUNT_KEY, 
        SESSION_STORAGE_AMERICO_OBJECT_KEY } from "../../../sessionStorage";
import "./Products.scss";

export default function Products(props) {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const cards = props.data.products.map((content, index) => 
    <ButtonCard 
      key={index} 
      id={index} 
      name={content.displayName} 
      target={content.openInNewTab ? "_blank" : "_self"} 
      icon={content.productIconPath} 
      href={content.productType === "term" ? props.journeys.termJourney : props.journeys.americoJourney} />);

  const getRowSize = (count) => {

    // For Count 7 and 8
    if (count === 7 || count === 8) {
      return "750";
    }
    // For Count 1 to 5
    else if (count < 6) {
      return "1120";
    }

    let countForSix = Math.floor(count / 6);
    let countForFive = Math.floor(count / 5);

    if (((countForSix * 6) - count) === 0) // For 6,12,18,24,....
      return "1120";
    else if (((countForFive * 5) - count) === 0) // For 10,15,20,25,30,.....
      return "930";
    else if (((countForSix + 1) * 6) - count < ((countForFive + 1) * 5) - count) // For diaplay column 5 or 6
      return "1120";
    else
      return "930";
  }

  const useStyles = makeStyles(theme => ({
    cardSize: {
      maxWidth: `${getRowSize(accountObj.accountProducts.length)}px`,
    }
  }));
  const classes = useStyles();

  return (
    <Container fluid className='business-solutions-products'>
      <Col className="product-container">
        <Row className={`product-desktop ${classes.cardSize} justify-content-center`}>
          {cards.map((obj, index) => <Col className={`carrier-card mt-2`} xs="auto" md="auto" key={index}>
            {obj}
          </Col>)}
        </Row>
      </Col>
    </Container>
  );
}

Products.propTypes = {
  data: PropTypes.shape({
    products: PropTypes.array,
  }),
  journeys: PropTypes.shape({
    americoJourney: PropTypes.string,
   termJourney: PropTypes.string,
  }),
  scrollElement: PropTypes.string,
}

export function ButtonCard(props) {

  const useStyles = makeStyles(theme => ({
    textcolor: {
      color: theme.palette.primary.main,
    },
    iconBackground: {
      backgroundColor: lighten(theme.palette.primary.main, 0.92)
    }
  }));

  const classes = useStyles();

  const onProductClick = (url) => {
    if(url === '/quote/term-life-insurance/loan-protector' || url === '/landing/loan-protector'){
      const sessionStorageData = getSessionStorageItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
      if(sessionStorageData) {
        sessionStorage.removeItem(SESSION_STORAGE_AMERICO_OBJECT_KEY);
        sessionStorage.removeItem('AMERICO_QUOTE');
      }
    }
    window.location.href = url;
  }

  return (

    <div className={`button-card d-flex align-items-center`}>
      <Button 
        type="submit" 
        onClick={() => onProductClick(props.href)} 
        variant="contained" 
        target={props.target}
        textPrimary={classes.textcolor}
        fullWidth ><span className={`name ${classes.iconBackground}`}><SvgIcon iconName={props.icon} className={classes.textcolor} /></span><span className={`name-text ${classes.textcolor}`}>{props.name}</span></Button>
    </div>
  )
}

ButtonCard.propTypes = {
  name: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  icon: PropTypes.string.isRequired,
  target: PropTypes.string,
  onClick: PropTypes.func,
  variantText: PropTypes.bool,
  shadow: PropTypes.bool,
  backgroundColor: PropTypes.string,
  href: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/Products/Products.js